const apiErrorZh = {
  'apiError.loginRequired': '请先登录',
  'apiError.forbidden': '无权访问',
  'apiError.csrfTokenMissing': '请求验证失败，请刷新页面后重试',
  'apiError.csrfTokenInvalid': '请求验证失败，请刷新页面后重试',
  'apiError.adminSessionRequired': '需要管理员权限',
  'apiError.enterpriseSessionRequired': '需要企业账号登录',
  'apiError.invalidRequestBody': '请求格式无效',
  'apiError.fileRequired': '请选择要上传的文件',
  'apiError.internalError': '系统异常，请稍后重试',
  'apiError.badRequest': '请求无效，请检查后重试',
  'apiError.channelCodeAlreadyExists': '渠道代码已存在',

  'apiError.requestBodyRequired': '请求内容不能为空',
  'apiError.validEmailRequired': '请输入有效的邮箱地址',
  'apiError.registerFieldsRequired': '请完整填写企业名称、联系人信息、邮箱和验证码',
  'apiError.privacyAgreementRequired': '请先阅读并同意隐私协议',
  'apiError.verificationCodeInvalidOrExpired': '验证码无效或已过期，请重新获取',
  'apiError.emailAlreadyExists': '该邮箱已被注册，请使用其他邮箱或直接登录',
  'apiError.channelNotFound': '报名渠道不存在',
  'apiError.registerFailed': '报名失败，请稍后重试',
  'apiError.idRequired': '缺少必要参数',
  'apiError.enterpriseNotFound': '企业不存在',
  'apiError.enterpriseNotPendingActivation': '该企业账号不在待激活状态',
  'apiError.activationLinkExpired': '激活链接已过期',
  'apiError.loginEmailMissing': '登录邮箱缺失',
  'apiError.activateFieldsRequired': '请填写验证码并设置密码',
  'apiError.activateFailed': '账号激活失败，请稍后重试',
  'apiError.accountRequired': '请输入账号',
  'apiError.enterpriseNotActivated': '该企业账号尚未激活',
  'apiError.enterpriseAccountNotReady': '企业账号尚未就绪',
  'apiError.resetPasswordFieldsRequired': '请填写验证码和新密码',
  'apiError.resetPasswordFailed': '密码重置失败，请稍后重试',
  'apiError.loginFieldsRequired': '请输入账号和密码',
  'apiError.usernameOrPasswordInvalid': '账号或密码错误',
  'apiError.tooManyFailedAttempts': '登录失败次数过多，请 {{minutes}} 分钟后再试',
  'apiError.enterpriseDeleted': '该企业账号已被删除',
  'apiError.passwordMinLength': '密码长度至少 8 位',
  'apiError.passwordComplexity': '密码需包含大写字母、小写字母、数字、符号中至少 3 类',
  'apiError.companyNameRequired': '请输入企业名称',
  'apiError.contactNameRequired': '请输入联系人姓名',
  'apiError.loginEmailRequired': '请输入登录邮箱',
  'apiError.validLoginEmailRequired': '请输入有效的登录邮箱',
  'apiError.loginEmailAlreadyExists': '该登录邮箱已被使用',
  'apiError.updateProfileFailed': '资料保存失败，请稍后重试',
  'apiError.proofFileUrlRequired': '请上传营业执照或工牌证明',
  'apiError.proofFileUrlMinOne': '请至少上传一个证明文件',
  'apiError.proofFileUrlJsonFormat': '证明文件格式无效',
  'apiError.proofFileUrlRequiredEach': '每个证明文件都需要有效地址',

  'apiError.enterpriseIdRequired': '缺少企业信息',
  'apiError.enterpriseIdMismatch': '企业信息不匹配，请重新登录',
  'apiError.surveyStatusInvalid': '问卷状态无效',
  'apiError.answersRequired': '请填写问卷答案',
  'apiError.questionIdRequired': '问卷题目信息缺失',
  'apiError.duplicateQuestionId': '问卷题目重复：{{id}}',
  'apiError.questionNotFound': '问卷题目不存在：{{id}}',
  'apiError.optionIdRequired': '请选择题目 {{id}} 的选项',
  'apiError.invalidOptionId': '题目 {{id}} 的选项无效',
  'apiError.textAnswerRequired': '请填写题目 {{id}} 的文本答案',
  'apiError.unsupportedQuestionType': '题目 {{id}} 类型不支持',
  'apiError.saveAnswersFailed': '问卷保存失败，请稍后重试',
  'apiError.updateSurveyProgressFailed': '问卷进度更新失败，请稍后重试',

  'apiError.base64Required': '图片数据无效',
  'apiError.fileSizeLimit': '文件大小不能超过 10 MB',
  'apiError.onlyJpgPngPdf': '仅支持 jpg / png / pdf 文件',
  'apiError.onlyPngJpg': '仅支持 png 或 jpg 图片',
  'apiError.invalidBase64ImageFormat': '图片格式无效',
  'apiError.invalidBase64ImageContent': '图片内容无效',
  'apiError.imageCompressFailed': '图片压缩失败，请更换文件后重试',
  'apiError.invalidUploadTarget': '上传目标无效',
  'apiError.saveImageFailed': '图片保存失败，请稍后重试',
  'apiError.saveFileFailed': '文件保存失败，请稍后重试',
  'apiError.readFileFailed': '文件读取失败，请稍后重试',
  'apiError.readImageFailed': '图片读取失败，请稍后重试',
  'apiError.jpgWriterUnavailable': '图片处理失败，请稍后重试',
  'apiError.compressImageFailed': '图片压缩失败，请稍后重试',

  'apiError.recipientEmailRequired': '收件邮箱不能为空',
  'apiError.userEmailRequired': '用户邮箱不能为空',
  'apiError.emailSendFailed': '邮件发送失败：{{detail}}',
  'apiError.emailServiceConnectionFailed': '邮件服务连接失败：{{detail}}',
};

const apiErrorZhTW = {
  'apiError.loginRequired': '請先登入',
  'apiError.forbidden': '無權存取',
  'apiError.csrfTokenMissing': '請求驗證失敗，請重新整理頁面後重試',
  'apiError.csrfTokenInvalid': '請求驗證失敗，請重新整理頁面後重試',
  'apiError.adminSessionRequired': '需要管理員權限',
  'apiError.enterpriseSessionRequired': '需要企業帳號登入',
  'apiError.invalidRequestBody': '請求格式無效',
  'apiError.fileRequired': '請選擇要上傳的文件',
  'apiError.internalError': '系統異常，請稍後重試',
  'apiError.badRequest': '請求無效，請檢查後重試',
  'apiError.channelCodeAlreadyExists': '渠道代碼已存在',

  'apiError.requestBodyRequired': '請求內容不能為空',
  'apiError.validEmailRequired': '請輸入有效的電子郵件地址',
  'apiError.registerFieldsRequired': '請完整填寫企業名稱、聯絡人資訊、電子郵件和驗證碼',
  'apiError.privacyAgreementRequired': '請先閱讀並同意隱私協議',
  'apiError.verificationCodeInvalidOrExpired': '驗證碼無效或已過期，請重新獲取',
  'apiError.emailAlreadyExists': '該電子郵件已被註冊，請使用其他電子郵件或直接登入',
  'apiError.channelNotFound': '報名渠道不存在',
  'apiError.registerFailed': '報名失敗，請稍後重試',
  'apiError.idRequired': '缺少必要參數',
  'apiError.enterpriseNotFound': '企業不存在',
  'apiError.enterpriseNotPendingActivation': '該企業帳號不在待激活狀態',
  'apiError.activationLinkExpired': '激活連結已過期',
  'apiError.loginEmailMissing': '登入電子郵件缺失',
  'apiError.activateFieldsRequired': '請填寫驗證碼並設置密碼',
  'apiError.activateFailed': '帳號激活失敗，請稍後重試',
  'apiError.accountRequired': '請輸入帳號',
  'apiError.enterpriseNotActivated': '該企業帳號尚未激活',
  'apiError.enterpriseAccountNotReady': '企業帳號尚未就緒',
  'apiError.resetPasswordFieldsRequired': '請填寫驗證碼和新密碼',
  'apiError.resetPasswordFailed': '密碼重置失敗，請稍後重試',
  'apiError.loginFieldsRequired': '請輸入帳號和密碼',
  'apiError.usernameOrPasswordInvalid': '帳號或密碼錯誤',
  'apiError.tooManyFailedAttempts': '登入失敗次數過多，請 {{minutes}} 分鐘後再試',
  'apiError.enterpriseDeleted': '該企業帳號已被刪除',
  'apiError.passwordMinLength': '密碼長度至少 8 位',
  'apiError.passwordComplexity': '密碼需包含大寫字母、小寫字母、數字、符號中至少 3 類',
  'apiError.companyNameRequired': '請輸入企業名稱',
  'apiError.contactNameRequired': '請輸入聯絡人姓名',
  'apiError.loginEmailRequired': '請輸入登入電子郵件',
  'apiError.validLoginEmailRequired': '請輸入有效的登入電子郵件',
  'apiError.loginEmailAlreadyExists': '該登入電子郵件已被使用',
  'apiError.updateProfileFailed': '資料保存失敗，請稍後重試',
  'apiError.proofFileUrlRequired': '請上傳營業執照或工牌證明',
  'apiError.proofFileUrlMinOne': '請至少上傳一個證明文件',
  'apiError.proofFileUrlJsonFormat': '證明文件格式無效',
  'apiError.proofFileUrlRequiredEach': '每個證明文件都需要有效地址',

  'apiError.enterpriseIdRequired': '缺少企業資訊',
  'apiError.enterpriseIdMismatch': '企業資訊不匹配，請重新登入',
  'apiError.surveyStatusInvalid': '問卷狀態無效',
  'apiError.answersRequired': '請填寫問卷答案',
  'apiError.questionIdRequired': '問卷題目資訊缺失',
  'apiError.duplicateQuestionId': '問卷題目重複：{{id}}',
  'apiError.questionNotFound': '問卷題目不存在：{{id}}',
  'apiError.optionIdRequired': '請選擇題目 {{id}} 的選項',
  'apiError.invalidOptionId': '題目 {{id}} 的選項無效',
  'apiError.textAnswerRequired': '請填寫題目 {{id}} 的文本答案',
  'apiError.unsupportedQuestionType': '題目 {{id}} 類型不支持',
  'apiError.saveAnswersFailed': '問卷保存失敗，請稍後重試',
  'apiError.updateSurveyProgressFailed': '問卷進度更新失敗，請稍後重試',

  'apiError.base64Required': '圖片數據無效',
  'apiError.fileSizeLimit': '文件大小不能超過 10 MB',
  'apiError.onlyJpgPngPdf': '僅支持 jpg / png / pdf 文件',
  'apiError.onlyPngJpg': '僅支持 png 或 jpg 圖片',
  'apiError.invalidBase64ImageFormat': '圖片格式無效',
  'apiError.invalidBase64ImageContent': '圖片內容無效',
  'apiError.imageCompressFailed': '圖片壓縮失敗，請更換文件後重試',
  'apiError.invalidUploadTarget': '上傳目標無效',
  'apiError.saveImageFailed': '圖片保存失敗，請稍後重試',
  'apiError.saveFileFailed': '文件保存失敗，請稍後重試',
  'apiError.readFileFailed': '文件讀取失敗，請稍後重試',
  'apiError.readImageFailed': '圖片讀取失敗，請稍後重試',
  'apiError.jpgWriterUnavailable': '圖片處理失敗，請稍後重試',
  'apiError.compressImageFailed': '圖片壓縮失敗，請稍後重試',

  'apiError.recipientEmailRequired': '收件電子郵件不能為空',
  'apiError.userEmailRequired': '用戶電子郵件不能為空',
  'apiError.emailSendFailed': '郵件發送失敗：{{detail}}',
  'apiError.emailServiceConnectionFailed': '郵件服務連接失敗：{{detail}}',
};

const apiErrorEn = {
  'apiError.loginRequired': 'Please sign in first.',
  'apiError.forbidden': 'Access denied.',
  'apiError.csrfTokenMissing': 'Request verification failed. Please refresh the page and try again.',
  'apiError.csrfTokenInvalid': 'Request verification failed. Please refresh the page and try again.',
  'apiError.adminSessionRequired': 'Admin access required.',
  'apiError.enterpriseSessionRequired': 'Enterprise account sign-in required.',
  'apiError.invalidRequestBody': 'Invalid request format.',
  'apiError.fileRequired': 'Please select a file to upload.',
  'apiError.internalError': 'System error. Please try again later.',
  'apiError.badRequest': 'Invalid request. Please check and try again.',
  'apiError.channelCodeAlreadyExists': 'Channel code already exists.',

  'apiError.requestBodyRequired': 'Request body is required.',
  'apiError.validEmailRequired': 'A valid email address is required.',
  'apiError.registerFieldsRequired':
    'Company name, contact details, email, and verification code are required.',
  'apiError.privacyAgreementRequired': 'Please read and accept the privacy agreement.',
  'apiError.verificationCodeInvalidOrExpired':
    'The verification code is invalid or has expired. Please request a new one.',
  'apiError.emailAlreadyExists':
    'This email is already registered. Please use a different email or sign in.',
  'apiError.channelNotFound': 'Registration channel not found.',
  'apiError.registerFailed': 'Registration failed. Please try again later.',
  'apiError.idRequired': 'Required parameter is missing.',
  'apiError.enterpriseNotFound': 'Enterprise not found.',
  'apiError.enterpriseNotPendingActivation': 'This enterprise account is not pending activation.',
  'apiError.activationLinkExpired': 'The activation link has expired.',
  'apiError.loginEmailMissing': 'Login email is missing.',
  'apiError.activateFieldsRequired': 'Verification code and password are required.',
  'apiError.activateFailed': 'Account activation failed. Please try again later.',
  'apiError.accountRequired': 'Account is required.',
  'apiError.enterpriseNotActivated': 'This enterprise account is not activated.',
  'apiError.enterpriseAccountNotReady': 'Enterprise account is not ready.',
  'apiError.resetPasswordFieldsRequired': 'Verification code and new password are required.',
  'apiError.resetPasswordFailed': 'Password reset failed. Please try again later.',
  'apiError.loginFieldsRequired': 'Username and password are required.',
  'apiError.usernameOrPasswordInvalid': 'Incorrect username or password.',
  'apiError.tooManyFailedAttempts':
    'Too many failed attempts. Please try again in {{minutes}} minutes.',
  'apiError.enterpriseDeleted': 'This enterprise account has been deleted.',
  'apiError.passwordMinLength': 'Password must be at least 8 characters.',
  'apiError.passwordComplexity':
    'Password must contain at least three of: uppercase, lowercase, digit, symbol.',
  'apiError.companyNameRequired': 'Company name is required.',
  'apiError.contactNameRequired': 'Contact name is required.',
  'apiError.loginEmailRequired': 'Login email is required.',
  'apiError.validLoginEmailRequired': 'A valid login email is required.',
  'apiError.loginEmailAlreadyExists': 'This login email is already in use.',
  'apiError.updateProfileFailed': 'Failed to save profile. Please try again later.',
  'apiError.proofFileUrlRequired': 'Please upload a business license or staff card.',
  'apiError.proofFileUrlMinOne': 'Please upload at least one proof file.',
  'apiError.proofFileUrlJsonFormat': 'Invalid proof file format.',
  'apiError.proofFileUrlRequiredEach': 'Each proof file must have a valid URL.',

  'apiError.enterpriseIdRequired': 'Enterprise information is required.',
  'apiError.enterpriseIdMismatch': 'Enterprise information mismatch. Please sign in again.',
  'apiError.surveyStatusInvalid': 'Invalid survey status.',
  'apiError.answersRequired': 'Survey answers are required.',
  'apiError.questionIdRequired': 'Question information is missing.',
  'apiError.duplicateQuestionId': 'Duplicate question: {{id}}',
  'apiError.questionNotFound': 'Question not found: {{id}}',
  'apiError.optionIdRequired': 'Please select an option for question {{id}}.',
  'apiError.invalidOptionId': 'Invalid option for question {{id}}.',
  'apiError.textAnswerRequired': 'Text answer is required for question {{id}}.',
  'apiError.unsupportedQuestionType': 'Unsupported question type for question {{id}}.',
  'apiError.saveAnswersFailed': 'Failed to save survey answers. Please try again later.',
  'apiError.updateSurveyProgressFailed': 'Failed to update survey progress. Please try again later.',

  'apiError.base64Required': 'Invalid image data.',
  'apiError.fileSizeLimit': 'File size must be 10 MB or less.',
  'apiError.onlyJpgPngPdf': 'Only jpg, png, and pdf files are supported.',
  'apiError.onlyPngJpg': 'Only png or jpg images are supported.',
  'apiError.invalidBase64ImageFormat': 'Invalid image format.',
  'apiError.invalidBase64ImageContent': 'Invalid image content.',
  'apiError.imageCompressFailed': 'Image compression failed. Please try another file.',
  'apiError.invalidUploadTarget': 'Invalid upload target.',
  'apiError.saveImageFailed': 'Failed to save image. Please try again later.',
  'apiError.saveFileFailed': 'Failed to save file. Please try again later.',
  'apiError.readFileFailed': 'Failed to read file. Please try again later.',
  'apiError.readImageFailed': 'Failed to read image. Please try again later.',
  'apiError.jpgWriterUnavailable': 'Image processing failed. Please try again later.',
  'apiError.compressImageFailed': 'Image compression failed. Please try again later.',

  'apiError.recipientEmailRequired': 'Recipient email is required.',
  'apiError.userEmailRequired': 'User email is required.',
  'apiError.emailSendFailed': 'Email send failed: {{detail}}',
  'apiError.emailServiceConnectionFailed': 'Email service connection failed: {{detail}}',
};

export const apiErrorResources = {
  zh: apiErrorZh,
  zh_TW: apiErrorZhTW,
  en: apiErrorEn,
};
